// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2tCL9","requiredAsterisk":"Info_requiredAsterisk__x_KQk"};